import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import NewIcon from '@mui/icons-material/Add';
import dateFormat from 'dateformat';
import isToday from 'dayjs/plugin/isToday';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import TitledSection from '../../common/TitledSection/TitledSection';
import CVBaseItem from '../../common/CVBaseItem/CVBaseItem';
import classes from './scss/historyListPB.module.scss';
import { cvUpdate } from '../../../actions/uploadData';
import AddEditCVRecord from '../../common/ModalWindows/AddEditCVRecord';
import ValidationErrorLabel from '../../common/ValidationErrorLabel/ValidationErrorLabel';
import colors from '../../../scss/colors';

dayjs.extend(isToday);

function WorkHistoryPB(props) {
  const { forErrors = false } = props;

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const historyItems = useSelector((state) =>
    !forErrors
      ? state.uploadData.parsedCV.JobExperienceDetails.map((item) => ({
          ...item,
          CompanyName: item?.EmployerName
        }))
      : state.uploadData.validationErrors.JobExperienceDetails?.map((item) => ({
          ...item,
          CompanyName: item?.EmployerName
        }))
  );

  const [openAddWindow, setAddWindow] = React.useState(false);

  const deleteHandler = (id) => {
    dispatch(cvUpdate({ flag: 'WorkDelete', value: id }));
  };

  const addWork = async (work) => {
    const start = new Date(work.startdate);
    start.setHours(0);
    const end = new Date(work.enddate);
    end.setHours(0);

    dispatch(
      cvUpdate({
        flag: 'WorkAdd',
        value: {
          id: uuidv4(),
          EmployerName: work.company,
          Title: work.title,
          Description: work.description,
          CurrentlyWorkThere: false,
          StartDate: dateFormat(start, 'isoDateTime'),
          EndDate: dateFormat(end, 'isoDateTime')
        }
      })
    );
    setAddWindow(false);
  };

  const updateWork = async (id, work) => {
    const start = new Date(work.startdate);
    start.setHours(0);
    const end = new Date(work.enddate);
    end.setHours(0);

    dispatch(
      cvUpdate({
        flag: 'WorkUpdate',
        value: {
          id,
          EmployerName: work.company,
          Title: work.title,
          Description: work.description,
          CurrentlyWorkThere: dayjs(work.enddate).isToday() ? work.currentlyWorkThere : false,
          StartDate: dateFormat(start, 'isoDateTime'),
          EndDate: dateFormat(end, 'isoDateTime')
        }
      })
    );
  };

  return (
    <TitledSection
      title={t('profile.builder.details.history')}
      actions={!forErrors && <NewIcon role="button" className={classes.action} onClick={() => setAddWindow(true)} />}
    >
      <hr className={classes.divider} />
      <div className={classes.list}>
        {openAddWindow && (
          <AddEditCVRecord
            withCurrentlyCheckBox={false}
            open
            closeHandler={() => setAddWindow(false)}
            editeMode={false}
            confirmHandler={addWork}
            block="works"
            shouldImmediatelySave
          />
        )}
        {historyItems?.length === 0 && (
          <ValidationErrorLabel message={t('dashboard.jobs.emptylist.noworkhistory')} color={colors.NAVY_BLUE} />
        )}
        {historyItems?.map((item) => (
          <Fragment key={item.id}>
            <CVBaseItem
              withCurrentlyCheckBox={false}
              item={item}
              block="works"
              deleteItem={() => deleteHandler(item?.id)}
              editItem={(data) => updateWork(item?.id, data)}
              shouldImmediatelySave
            />
          </Fragment>
        ))}
      </div>
    </TitledSection>
  );
}

export default WorkHistoryPB;
